const collections = document.querySelectorAll('.count-tile-items--collection')

if (collections.length) {
  const formatter = new Intl.NumberFormat('de-DE')

  const parseTarget = (el) => {
    const raw = String(el.dataset.countTarget || '').replace(/\D/g, '')
    return parseInt(raw, 10)
  }

  const animateCount = (el) => {
    const target = parseTarget(el)
    if (!target) return

    const duration = 2200
    const start = performance.now()

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1)
      const eased = 1 - Math.pow(1 - progress, 3)
      el.textContent = formatter.format(Math.round(target * eased))
      if (progress < 1) {
        requestAnimationFrame(tick)
      } else {
        el.textContent = formatter.format(target)
      }
    }

    requestAnimationFrame(tick)
  }

  const handleIntersect = (entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      entry.target.querySelectorAll('.count-tile--number').forEach(animateCount)
      observer.unobserve(entry.target)
    })
  }

  const observer = new IntersectionObserver(handleIntersect, {
    threshold: 0.2,
    rootMargin: '0px 0px -10% 0px'
  })

  collections.forEach((c) => {
    c.querySelectorAll('.count-tile--number').forEach((el) => {
      if (el.dataset.countTarget) {
        el.textContent = '0'
      }
    })
    observer.observe(c)
  })
}
